/**
 * Enum for the types of questionnaires
 * @enum {string}
 * @property {string} OPEN_ENDED - Open ended questionnaire
 * @property {string} CLOSED_ENDED - Closed ended questionnaire
 * @property {string} CHOICE_BASED - Choice based questionnaire
 */
export enum QuestionnaireType {
  OPEN_ENDED = 'OPEN_ENDED',
  CLOSED_ENDED = 'CLOSED_ENDED',
  CHOICE_BASED = 'CHOICE_BASED',
}

/**
 * Enum for questionnaire placement in inspection flow
 * @enum {string}
 * @property {string} BEGINNING - Show questionnaire after checklist
 * @property {string} END - Show questionnaire after damage reporting
 */
export enum QuestionnairePlacement {
  BEGINNING = 'BEGINNING',
  END = 'END',
}

/**
 * Enum for sorting fields of inspection flows
 * @enum {string}
 * @property {string} id - Sort by ID
 * @property {string} title - Sort by title
 * @property {string} status - Sort by status
 * @property {string} executionTime - Sort by execution time
 * @property {string} createdAt - Sort by creation date
 */
export enum InspectionFlowSortField {
  id = 'id',
  title = 'title',
  status = 'status',
  executionTime = 'executionTime',
  createdAt = 'createdAt',
}

/**
 * Enum for flow status
 * @readonly
 * @enum {string}
 * @property {string} ACTIVE - 'ACTIVE'
 * @property {string} INACTIVE - 'INACTIVE'
 * @property {string} DELETED - 'DELETED'
 */
export enum FlowStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
}

/**
 * Enum for inspection flow types
 * @enum {string}
 * @property {string} VISUAL - Full Inspection / Visual Inspection flow
 * @property {string} TIRE - Tire only inspection flow
 * @property {string} BEFORE_AFTER - Before and after inspection flow
 * @property {string} EXPEDITED_AI - Optimal AI Inspection flow (fixed required capture set)
 */
export enum InspectionFlowType {
  VISUAL = 'VISUAL',
  TIRE = 'TIRE',
  BEFORE_AFTER = 'BEFORE_AFTER',
  EXPEDITED_AI = 'EXPEDITED_AI',
}

/**
 * Enum for inspection flow services
 * @enum {string}
 * @property {string} EST - EST inspection flow service
 * @property {string} AIwH - AIwH inspection flow service including both CR and AI
 * @property {string} TIRE - TIRE inspection flow service
 */
export enum InspectionFlowService {
  EST = 'EST',
  AIwH = 'AIwH',
  TIRE = 'Tire',
}

/**
 * Allowlist of optional fields the short flow selector may include.
 * `id`, `title`, `locationId` and `companyId` are always returned and are not part of this enum.
 * @enum {string}
 */
export enum FlowSelectorInclude {
  status = 'status',
  flowType = 'flowType',
  services = 'services',
  description = 'description',
}
